/**
 * Created by Anastasiya on 11.06.2024
 */

const TradeUnitDescription = cc.Node.extend({
    ctor: function (tradeType, trade) {
        this._super();
        this.tradeType = tradeType;
        this.trade = trade;

        const styles = cleverapps.styles.TradeUnitDescription;
        this.setContentSize(styles);
        this.createDescription();
        this.createUnit();

        trade.on("pickChange", this.updateSelected.bind(this), this);
    },

    createDescription: function () {
        const styles = cleverapps.styles.TradeUnitDescription.desc;

        const bg = this.descBg = cleverapps.UI.createScale9Sprite(bundles.tradewindow.frames.light_bg);
        bg.setContentSize(styles);
        bg.setAnchorPoint(this.tradeType === UnitTrade.SOURCE ? 0 : 1, 0.5);
        const posX = this.tradeType === UnitTrade.SOURCE ? 0 : this.width;
        bg.setAlignment(posX, this.height / 2);
        this.addChild(bg);

        const arrow = new cc.Sprite(bundles.tradewindow.frames.dialogue_arrow);
        arrow.setScaleX(this.tradeType === UnitTrade.SOURCE ? 1 : -1);
        const arrowX = this.tradeType === UnitTrade.SOURCE ? bg.width + styles.arrowOffsetX : -styles.arrowOffsetX;
        arrow.setAlignment(arrowX, bg.height / 2);
        bg.addChild(arrow);

        this.createDescriptionText();
    },

    createDescriptionText: function (unit) {
        const styles = cleverapps.styles.TradeUnitDescription.desc.text;
        if (unit) {
            this.text = this.getUnitText(unit);
        } else {
            const msg = this.tradeType === UnitTrade.SOURCE ? "TradeWindow.HintSelectTradeable" : "TradeWindow.HintSelectAvailable";
            this.text = cleverapps.UI.generateOnlyText(Messages.get(msg), cleverapps.styles.FONTS.TRADE_WINDOW_DESCRIPTION);
            this.text.setDimensions(this.descBg.width - styles.paddingX, 0);
            this.text.fitTo(undefined, this.descBg.height - styles.paddingY);
        }
        this.text.setCascadeOpacityEnabledRecursively(true);
        this.text.setAlignment(styles);
        this.descBg.addChild(this.text);
    },

    getUnitText: function (unit) {
        const styles = cleverapps.styles.TradeUnitDescription.desc.text;
        const rarityText = {
            "clpet": "TradeWindow.Rarity.Regular",
            "clpetrare": "TradeWindow.Rarity.Rare",
            "clpetlegend": "TradeWindow.Rarity.Legendary"
        };

        const name = cleverapps.UI.generateOnlyText(cleverapps.unitsLibrary.getUnitName(unit), cleverapps.styles.FONTS.TRADE_WINDOW_DESCRIPTION);
        name.fitTo(this.descBg.width - styles.paddingX);

        const rarity = new TextWithIcon(`%% ${Messages.get(rarityText[unit.type])}`, {
            font: cleverapps.styles.FONTS.TRADE_WINDOW_DESCRIPTION,
            icons: {
                "%%": this.trade.getIconByType(unit.type)
            }
        });

        return new cleverapps.Layout([rarity, name], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createUnit: function () {
        const styles = cleverapps.styles.TradeUnitDescription.unit;
        const unitCell = this.unitCell = new cc.Sprite(bundles.tradewindow.frames.ground);
        unitCell.setAnchorPoint(this.tradeType === UnitTrade.SOURCE ? 1 : 0, 0.5);
        unitCell.setAlignment(this.tradeType === UnitTrade.SOURCE ? this.width : 0, this.height / 2 + styles.offsetY);
        this.addChild(unitCell);

        this.createUnitIcon();
    },

    createUnitIcon: function (unit) {
        const styles = cleverapps.styles.TradeUnitDescription.unit.icon;
        if (unit) {
            this.unitIcon = UnitView.getUnitImage(unit, { preferStatic: true, alignAnchorY: true });
            cleverapps.UI.fitToBox(this.unitIcon, styles);
        } else {
            this.unitIcon = new cc.Node();
        }
        this.unitIcon.setAlignment(styles);
        this.unitCell.addChild(this.unitIcon);
    },

    updateSelected: function (type, newUnit) {
        if (this.tradeType !== type) {
            return;
        }

        const duration = 0.4;
        const oldText = this.text;
        this.createDescriptionText(newUnit);
        this.upgradeAction && this.upgradeAction.finalize();
        oldText.stopAllActions();
        oldText.runAction(new cc.Sequence(
            new cc.FadeOut(duration),
            new cc.RemoveSelf()
        ));
        this.text.setOpacity(0);
        this.text.runAction(new cc.Sequence(
            new cc.DelayTime(duration),
            new cc.FadeIn(duration)
        ));

        const oldUnit = this.unitIcon;
        this.createUnitIcon(newUnit);
        this.unitIcon.setVisible(false);

        this.upgradeAction = oldUnit.runAction(UnitView.runUpgradeAnimation(oldUnit, this.unitIcon).setFinalize(() => {
            oldUnit.removeFromParent();
        }));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TRADE_WINDOW_DESCRIPTION: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.TradeUnitDescription = {
    width: 630,
    height: 150,

    unit: {
        offsetY: -7,
        icon: {
            width: 150,
            height: 150,
            x: { align: "center" },
            y: { align: "bottom", dy: 25 }
        }
    },

    desc: {
        width: 435,
        height: 150,
        offsetX: 10,
        arrowOffsetX: 6,

        text: {
            paddingX: 60,
            paddingY: 50,
            margin: 2,
            x: { align: "center" },
            y: { align: "center", dy: 5 }
        }
    }
};